export function validateIntegerId(value: any): boolean {
  if (typeof value !== 'number') {
    return false;
  }
  return value > 0;
}
